class IARevealOnScroll {
  constructor(options = {}) {
    this.settings = {
      selector: '[data-ia-ros], .ia-js-ros',
      revealedClass: 'ia-revealed',
      initClass: 'ia-reveal',
      threshold: 0.15,
      rootMargin: '0px 0px -10% 0px',
      delay: 0,
      ...options
    };

    this.observer = null;
    this.items = [];

    this.controllersById = new Map();
    this.controlledById = new Map();
    this.triggeredControllerIds = new Set();
    this.missingControllerIdsHandled = new Set();
  }

  init(scope = document) {
    const newItems = [...scope.querySelectorAll(this.settings.selector)];

    if (!newItems.length) return;

    if (!this.observer) {
      this.observer = new IntersectionObserver(
        this.handleIntersect.bind(this),
        {
          threshold: this.settings.threshold,
          rootMargin: this.settings.rootMargin
        }
      );
    }

    newItems.forEach((item) => {
      if (item.__iaRosInitialized) return;

      item.__iaRosInitialized = true;
      this.items.push(item);

      this.prepareItem(item);

      const controllerId = item.getAttribute('data-ia-ros-controller');
      const controlledById = item.getAttribute('data-ia-ros-controlled-by');

      if (controllerId) {
        if (!this.controllersById.has(controllerId)) {
          this.controllersById.set(controllerId, []);
        }
        this.controllersById.get(controllerId).push(item);

        this.observer.observe(item);
        return;
      }

      if (controlledById) {
        if (!this.controlledById.has(controlledById)) {
          this.controlledById.set(controlledById, []);
        }
        this.controlledById.get(controlledById).push(item);

        return;
      }

      this.observer.observe(item);
    });

    this.controlledById.forEach((items, id) => {
      if (this.controllersById.has(id)) return;
      if (this.missingControllerIdsHandled.has(id)) return;

      this.missingControllerIdsHandled.add(id);

      items.forEach((item) => {
        this.revealItem(item);
      });
    });
  }

  prepareItem(item) {
    item.classList.add(this.settings.initClass);

    const delay = item.dataset.iaRosDelay || this.settings.delay;
    item.style.setProperty('--ia-ros-delay', `${delay}ms`);
  }

  revealItem(item) {
    item.classList.add(this.settings.revealedClass);
    item.setAttribute('data-ia-revealed', '');

    if (this.observer) {
      this.observer.unobserve(item);
    }
  }

  handleIntersect(entries) {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;

      const item = entry.target;

      const controllerId = item.getAttribute('data-ia-ros-controller');

      if (controllerId) {
        this.revealItem(item);

        if (!this.triggeredControllerIds.has(controllerId)) {
          this.triggeredControllerIds.add(controllerId);

          const controlledItems = this.controlledById.get(controllerId);

          if (controlledItems && controlledItems.length) {
            controlledItems.forEach((controlledItem) => {
              this.revealItem(controlledItem);
            });
          }
        }

        return;
      }

      this.revealItem(item);
    });
  }
}

/* ----------------------------
   Init
----------------------------- */
const ros = new IARevealOnScroll();

document.addEventListener('DOMContentLoaded', () => {
  ros.init();
});

/* Shopify theme editor support */
document.addEventListener('shopify:section:load', (event) => {
  ros.init(event.target);
});

